import React from 'react';
import { Mail, MapPin, Linkedin, Twitter } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    product: {
      title: 'Ürün',
      links: ['Özellikler', 'Entegrasyonlar', 'Güvenlik', 'Fiyatlandırma']
    },
    company: {
      title: 'Şirket',
      links: ['Hakkımızda', 'Kariyer', 'Blog', 'Basın']
    },
    resources: {
      title: 'Kaynaklar',
      links: ['Dokümantasyon', 'API', 'Destek', 'SSS']
    },
    legal: {
      title: 'Yasal',
      links: ['Gizlilik Politikası', 'Kullanım Şartları', 'Çerez Politikası', 'KVKK']
    }
  };

  return (
    <footer className="bg-slate-900 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-8 lg:gap-12">
          {/* Brand Column */}
          <div className="col-span-2">
            <div className="text-2xl font-bold mb-4">
              <span className="text-blue-400">CAPS</span>NA
            </div>
            <p className="text-slate-400 mb-6 max-w-xs">
              Kurumsal ölçekte doküman yönetimi ve yapay zeka destekli analiz platformu.
            </p>
            <div className="space-y-3">
              <a href="mailto:selim@pdtech.com.tr" className="flex items-center gap-3 text-slate-400 hover:text-white transition-colors">
                <Mail size={18} />
                <span>selim@pdtech.com.tr</span>
              </a>
              <div className="flex items-center gap-3 text-slate-400">
                <MapPin size={18} />
                <span>Türkiye</span>
              </div>
            </div>
          </div>

          {/* Links Columns */}
          {Object.entries(footerLinks).map(([key, section]) => (
            <div key={key}>
              <h4 className="font-semibold text-white mb-4">{section.title}</h4>
              <ul className="space-y-3">
                {section.links.map((link, idx) => (
                  <li key={idx}>
                    <a
                      href="#"
                      className="text-slate-400 hover:text-white transition-colors text-sm"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-slate-500 text-sm">
              © {currentYear} CAPSNA. Tüm hakları saklıdır.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="#"
                className="w-10 h-10 rounded-lg bg-slate-800 flex items-center justify-center text-slate-400 hover:bg-blue-600 hover:text-white transition-all duration-300"
              >
                <Linkedin size={20} />
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-lg bg-slate-800 flex items-center justify-center text-slate-400 hover:bg-blue-600 hover:text-white transition-all duration-300"
              >
                <Twitter size={20} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
